import {SET_LIST_SELECTED_IDS} from 'react-admin';

export const setListSelectedIds = (resource, ids) => ({
    type: SET_LIST_SELECTED_IDS,
    payload: ids,
    meta: {
        resource: resource
    }
});